import React from "react";

export const Title = ({
  children,
  fontSize = "4xl",
  color = "primary",
  margin = "4",
  className: _class,
}) => {
  const className = `text-${fontSize} mb-${margin} text-${color} font-semibold ${_class}`;

  return <h2 className={className}>{children}</h2>;
};

export default Title;
